// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__uE9k4","rootSuccess":"CompleteLink_rootSuccess__k21Ub","rootFailure":"CompleteLink_rootFailure__2E0wR","isDisabled":"CompleteLink_isDisabled__3ujZp"};